import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import './index.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
// import './theme-styles.css';
import './customized-theme-styles.css';
import { Amplify } from 'aws-amplify';
import Config from './config.env.js';
import amplifyConfig from './aws-config.js';

Config();
const root = ReactDOM.createRoot(document.getElementById('root'));
Amplify.configure(amplifyConfig);

root.render(
  <Router>
    <React.Fragment>
      <App />
    </React.Fragment>
  </Router>,
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
